// Generated by scripts/update-seeq-icons.js from src/svg/seeq/report.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcReport = {
  prefix: 'fak',
  iconName: 'report' as IconName,
  icon: [
    822,
    1024,
    [],
    'f947',
    'M718.3 97.1h-96.3v-35.6c0-34-27.5-61.5-61.5-61.5h-300.1c-34 0-61.5 27.5-61.4 61.5v35.6h-96.3c-56.6 0-102.7 46.1-102.7 102.7v721.5c0 56.6 46.1 102.7 102.7 102.7h615.6c56.6 0 102.7-46.1 102.7-102.7v-721.5c0-56.6-46.1-102.7-102.7-102.7zM513.6 194.1h-205.4v-84.9h205.4v84.9zM712.6 915.6h-603.4v-709.3h89.8v34.7c0 34 27.5 61.5 61.4 61.5h300.1c34 0 61.5-27.5 61.5-61.5v-34.7h89.8v709.3h0.8z',
  ],
} satisfies IconDefinition;
